import { environment } from '@env/environment';
import { Paginate } from '@model/Paginate';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Sticker } from '@model/Sticker';

@Injectable({ providedIn: 'root' })
export class ReminderService {

  constructor(private http: HttpClient) {
  }

  paginate(page: number = 1): Observable<Paginate<Sticker>> {
    return this.http.get<Paginate<Sticker>>(`${environment.base_url}/reminders?page=${page}`);
  }
}
